// Services.
import {WaHelperService} from '../../wa-services/wa-helper-service';


// Utility.
import {StringTools} from '../../util/strings-tools';


export class AthleteGeneralInfoItem {

  public id: number;
  public fName: string;
  public gName: string;
  public wNameOrd: boolean;
  public noc: string;
  protected _completeName: string;
  protected _completeNameHtml: string;
  protected _countryName: string;
  protected _favourite: boolean;

  constructor(rawAthleteGeneralInfoItem: any, protected waHelperService: WaHelperService) {
    this.id = rawAthleteGeneralInfoItem.Id;
    this.fName = rawAthleteGeneralInfoItem.FName;
    this.gName = rawAthleteGeneralInfoItem.GName;
    this.wNameOrd = rawAthleteGeneralInfoItem.WNameOrd;
    this.noc = rawAthleteGeneralInfoItem.NOC;

    // Calculate complete name.
    if (this.wNameOrd) {
      this._completeName = this.fName + ' ' + this.gName;
      this._completeNameHtml = '<strong>' + this.fName + ' </strong> ' + this.gName;
    }
    else {
      this._completeName = this.gName + ' ' + this.fName;
      this._completeNameHtml = this.gName + ' <strong>' + this.fName + '</strong>';
    }

    // Get country name.
    this._countryName = this.waHelperService.nocToCountryName(this.noc);

    // Athlete by default set to not favourite.
    this._favourite = false;
  }

  public static athleteSortFn(a: AthleteGeneralInfoItem, b: AthleteGeneralInfoItem) {
    var nameA = a.completeName.toUpperCase(); // ignore upper and lowercase
    var nameB = b.completeName.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // Names must be equal.
    return 0;
  }

  get completeName(): string {
    return this._completeName;
  }

  get completeNameHtml(): string {
    return this._completeNameHtml;
  }

  get countryName(): string {
    return this._countryName;
  }

  set favourite(fav: boolean) {
    this._favourite = fav;
  }

  get favourite(): boolean {
    return this._favourite;
  }

  get picUrl(): string {
    return `https://extranet.worldarchery.sport/ProfilePictures/?Id=${this.id}`;
  }

  get flagPic(): string {
    return this.waHelperService.nocToFlagUrl(this.noc);
  }

  get webUrl(): string {
    return 'https://worldarchery.sport/athlete/' + this.id;
  }

  get nameInitial(): string {
    let initial: string;
    if (this.fName && this.fName !== '.' && this.fName !== '-') {
      initial = this.fName[0];
    }
    else if (this.gName && this.gName !== '.' && this.gName !== '-') {
      initial = this.gName[0];
    }

    if (initial) {
      initial = StringTools.transliterate(initial);
    }

    return initial;
  }

}
